module.exports = __webpack_public_path__ + "img/desc.4560a001.svg";